<template>
    <div>
        <div id="preloader">
            <div id="status">
                <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                </div>
            </div>
        </div>
        <div id="layout-wrapper">
            <HorizontalTopbarInside/>
            <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth"/>
            <div class="main-content">
                <div class="page-content">
                    <!-- Start Content-->
                    <div class="container-fluid">
                        <slot/>
                    </div>
                </div>
                <Footer/>
                <h2 class="mt-5">{{$t('message.Enter_information')}}</h2>
                <div class="px-5">
                    <b-card>
                        <validation-observer class="w-100" ref="observer">
                            <b-row>
                                <b-col md="8" offset="2">
                                    <div
                                            style="width: 100%;">
                                        <label>{{$t('message.Position_level')}}</label>
                                        <validation-provider rules="required" v-slot="{errors}" name="Lavozim darajasi">
                                            <b-form-select
                                                    v-model="form.position_level_id"
                                                    :options="position_level"
                                                    text-field="name_uz"
                                                    value-field="id"
                                                    @input="fetchPosition"
                                                    class="form-select d-flex"
                                                    aria-label="Default select example"></b-form-select>
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                                                        <br>
                                                                        <div class="w-100">
                                                                            <label>{{$t('message.Positions')}}</label>
                                                                            <validation-provider rules="required" v-slot="{errors}" name="Lavozim">
                                                                                <b-form-select
                                                                                        v-model="form.position_id"
                                                                                        :options="positions"
                                                                                        text-field="name_uz"
                                                                                        value-field="id"
                                                                                        class="form-select d-flex"
                                                                                        aria-label="Default select example"></b-form-select>
                                                                                <span class="text-danger">{{errors[0]}}</span>
                                                                            </validation-provider>
                                                                        </div>
                                    <br>


<!--                                </b-col> <br><br>-->
<!--                                <b-col md="8" offset="2">-->
                                    <div class="w-100">
                                        <label>{{$t('Job description')}}</label>
                                        <validation-provider rules="required" v-slot="{errors}"
                                                             :name="$t('message.Language_of_instruction')">
                                            <quill-editor
                                                    ref="myQuillEditor"
                                                    v-model="form.description"
                                                    :options="editorOption"
                                            />
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                    <br><div class="w-100">
                                        <label>{{$t('message.Submission_deadline')}}:</label><br>
                                        <validation-provider rules="required" v-slot="{errors}"
                                                             :name="$t('message.Submission_deadline')">
                                            <input class="form-control" type="date" v-model="form.deadline">
                                            <span class="text-danger">{{errors[0]}}</span>
                                        </validation-provider>
                                    </div>
                                </b-col>

                                <!--                                <b-col md="6">-->
                                <!--            <div-->
                                <!--                style="width: 50%;-->
                                <!--                margin-left: 68px">-->
                                <!--            <label>Hudud(Tuzilma)</label>-->
                                <!--            <b-form-select-->
                                <!--                v-model="form.region_id"-->
                                <!--                :options="regions"-->
                                <!--                text-field="nameuz"-->
                                <!--                value-field="id"-->
                                <!--                @input="fetchRayons"-->
                                <!--                class="form-select d-flex"-->
                                <!--                aria-label="Default select example"></b-form-select>-->
                                <!--          </div>-->
                                <!--            <br>-->
                                <!--            <div-->
                                <!--                style="width: 50%;-->
                                <!--                margin-left: 68px">-->
                                <!--            <label>Tuman(Tuzilma)</label>-->
                                <!--            <b-form-select-->
                                <!--              v-model="form.rayon_id"-->
                                <!--              :options="rayons"-->
                                <!--              text-field="nameuz"-->
                                <!--              value-field="id"-->
                                <!--              @input="fetchSchools"-->
                                <!--              class="form-select d-flex"-->
                                <!--              aria-label="Default select example"></b-form-select>-->
                                <!--            </div>-->
                                <!--            <br>-->
                                <!--            <div-->
                                <!--                style="width: 50%;-->
                                <!--                margin-left: 68px">-->
                                <!--            <label>Muassasa</label>-->
                                <!--            <b-form-select-->
                                <!--                v-model="form.school_id"-->
                                <!--                :options="schools"-->
                                <!--                text-field="organizationshortname"-->
                                <!--                value-field="organizationid"-->
                                <!--                class="form-select d-flex"-->
                                <!--                aria-label="Default select example"></b-form-select>-->
                                <!--            </div>-->
                                <!--            <br>-->
                                <!--                                    <div-->
                                <!--                                            style="width: 100%;">-->
                                <!--                                        <label>{{$t('message.Position_level')}}</label>-->
                                <!--                                        <validation-provider rules="required" v-slot="{errors}" name="Lavozim darajasi">-->
                                <!--                                            <b-form-select-->
                                <!--                                                    v-model="form.position_level_id"-->
                                <!--                                                    :options="position_level"-->
                                <!--                                                    text-field="name_uz"-->
                                <!--                                                    value-field="id"-->
                                <!--                                                    @input="fetchPosition"-->
                                <!--                                                    class="form-select d-flex"-->
                                <!--                                                    aria-label="Default select example"></b-form-select>-->
                                <!--                                            <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                        </validation-provider>-->
                                <!--                                    </div>-->
                                <!--                                    <br>-->
                                <!--                                    <div class="w-100">-->
                                <!--                                        <label>{{$t('message.Positions')}}</label>-->
                                <!--                                        <validation-provider rules="required" v-slot="{errors}" name="Lavozim">-->
                                <!--                                            <b-form-select-->
                                <!--                                                    v-model="form.position_id"-->
                                <!--                                                    :options="positions"-->
                                <!--                                                    text-field="name_uz"-->
                                <!--                                                    value-field="id"-->
                                <!--                                                    class="form-select d-flex"-->
                                <!--                                                    aria-label="Default select example"></b-form-select>-->
                                <!--                                            <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                        </validation-provider>-->
                                <!--                                    </div>-->
                                <!--                                    <b-row>-->
                                <!--                                        <b-col md="4">-->
                                <!--                                            <div style="margin-top: 20px">-->
                                <!--                                                <label>{{$t('message.Vacancy_count')}}</label>-->
                                <!--                                                <br>-->
                                <!--                                                <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                                     name="Ish o'rinlar soni">-->
                                <!--                                                    <b-form-spinbutton-->
                                <!--                                                            class="w-75 text-center"-->
                                <!--                                                            id="sb-inline"-->
                                <!--                                                            v-model="form.vacancy_count"-->
                                <!--                                                            inline></b-form-spinbutton>-->
                                <!--                                                    <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                                </validation-provider>-->
                                <!--                                            </div>-->
                                <!--                                        </b-col>-->
                                <!--                                        <b-col md="8">-->
                                <!--                                            <br>-->
                                <!--                                            <div class="w-100">-->
                                <!--                                                <label>{{$t('message.Job_Types')}}</label>-->
                                <!--                                                <validation-provider rules="required" v-slot="{errors}" name="Ish turi">-->
                                <!--                                                    <b-form-select-->
                                <!--                                                            v-model="form.job_type_id"-->
                                <!--                                                            :options="job_type"-->
                                <!--                                                            text-field="name"-->
                                <!--                                                            value-field="id"-->
                                <!--                                                            class="form-select d-flex"-->
                                <!--                                                            aria-label="Default select example"></b-form-select>-->
                                <!--                                                    <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                                </validation-provider>-->
                                <!--                                            </div>-->
                                <!--                                        </b-col>-->
                                <!--                                    </b-row>-->
                                <!--                                    <b-row class="w-100 mt-4">-->
                                <!--                                        <b-col md="6">-->
                                <!--                                            <div class="w-100">-->
                                <!--                                                <label>{{$t('message.PaymentTypes')}}</label>-->
                                <!--                                                <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                                     name="To'lov turi">-->
                                <!--                                                    <b-form-select-->
                                <!--                                                            v-model="form.payment_type_id"-->
                                <!--                                                            :options="payment_type"-->
                                <!--                                                            text-field="name"-->
                                <!--                                                            value-field="id"-->
                                <!--                                                            class="form-select"-->
                                <!--                                                            aria-label="Default select example"></b-form-select>-->
                                <!--                                                    <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                                </validation-provider>-->
                                <!--                                            </div>-->
                                <!--                                        </b-col>-->
                                <!--                                        <b-col md="6">-->
                                <!--                                            <div class="w-100">-->
                                <!--                                                <label>{{$t('message.Salary')}}</label>-->
                                <!--                                                <b-form-group-->
                                <!--                                                        label-for="name-input"-->
                                <!--                                                        invalid-feedback="Name is required"-->
                                <!--                                                >-->
                                <!--                                                    <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                                         :name="$t('message.Salary')">-->
                                <!--                                                        <b-form-input-->
                                <!--                                                                v-model="form.salary"-->
                                <!--                                                                type="number"-->
                                <!--                                                                required-->
                                <!--                                                                id="input-default"-->
                                <!--                                                                class="w-100"-->
                                <!--                                                        ></b-form-input>-->
                                <!--                                                        <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                                    </validation-provider>-->
                                <!--                                                </b-form-group>-->
                                <!--                                            </div>-->
                                <!--                                        </b-col>-->
                                <!--                                    </b-row>-->
                                <!--                                    <div class="w-100 mt-4">-->
                                <!--                                        <b-form-group-->
                                <!--                                                :label="$t('message.Privileges')"-->
                                <!--                                                label-for="name-input"-->
                                <!--                                                invalid-feedback="Name is required"-->
                                <!--                                        >-->
                                <!--                                            <b-form-input-->
                                <!--                                                    v-model="form.privileges"-->
                                <!--                                                    type="text"-->
                                <!--                                                    required-->
                                <!--                                                    id="input-default"-->
                                <!--                                            ></b-form-input>-->
                                <!--                                        </b-form-group>-->
                                <!--                                    </div>-->
                                <!--                                    <b-row class="mt-4">-->

                                <!--                    <b-col md="6">-->
                                <!--                      <div>-->
                                <!--                        <label>{{$t('message.Workplace_employment')}}</label>-->
                                <!--                        <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Workplace_employment')">-->
                                <!--                          <b-form-select-->
                                <!--                              v-model="form.workplace_employment_id"-->
                                <!--                              :options="work_place"-->
                                <!--                              text-field="name"-->
                                <!--                              value-field="id"-->
                                <!--                              class="form-select"-->
                                <!--                              aria-label="Default select example"></b-form-select>-->
                                <!--                          <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                        </validation-provider>-->
                                <!--                      </div>-->
                                <!--                    </b-col>-->
                                <!--                                    </b-row>-->
                                <!--                                </b-col>-->
                                <!--                                <b-col md="6">-->


                                <!--                                    <div class="w-100">-->
                                <!--                                        <label>{{$t('message.Language_of_instruction')}}</label>-->
                                <!--                                        <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                             :name="$t('message.Language_of_instruction')">-->
                                <!--                                            <b-form-select-->
                                <!--                                                    v-model="form.lesson_language_id"-->
                                <!--                                                    :options="lesson_language"-->
                                <!--                                                    text-field="name"-->
                                <!--                                                    value-field="id"-->
                                <!--                                                    class="form-select d-flex"-->
                                <!--                                                    aria-label="Default select example"></b-form-select>-->
                                <!--                                            <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                        </validation-provider>-->
                                <!--                                    </div>-->
                                <!--                                    <br>-->
                                <!--                                    <div class="w-100">-->
                                <!--                                        <label>{{$t('message.Work_experience')}}</label>-->
                                <!--                                        <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                             :name="$t('message.Work_experience')">-->
                                <!--                                            <b-form-select-->
                                <!--                                                    v-model="form.work_experience_id"-->
                                <!--                                                    :options="work_experience"-->
                                <!--                                                    text-field="name"-->
                                <!--                                                    value-field="id"-->
                                <!--                                                    class="form-select d-flex"-->
                                <!--                                                    aria-label="Default select example"></b-form-select>-->
                                <!--                                            <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                        </validation-provider>-->
                                <!--                                    </div>-->
                                <!--                  <br>-->
                                <!--                  <div class="w-100 mt-1">-->
                                <!--                    <label>{{$t('message.Education')}}</label>-->
                                <!--                    <validation-provider rules="required" v-slot="{errors}" :name="$t('message.Education')">-->
                                <!--                      <b-form-select-->
                                <!--                          v-model="form.education_id"-->
                                <!--                          :options="education"-->
                                <!--                          text-field="name"-->
                                <!--                          value-field="id"-->
                                <!--                          class="form-select d-flex"-->
                                <!--                          aria-label="Default select example"></b-form-select>-->
                                <!--                      <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                    </validation-provider>-->
                                <!--                  </div>-->
                                <!--                                    <div class="w-100">-->
                                <!--                                        <label class="mt-4 d-flex">{{$t('message.Phone_tocall')}}</label>-->
                                <!--                                        <b-form-group-->
                                <!--                                                label-for="name-input"-->
                                <!--                                                invalid-feedback="Name is required"-->
                                <!--                                        >-->
                                <!--                                            <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                                 :name="$t('message.Phone_tocall')">-->
                                <!--                                                <b-form-input-->
                                <!--                                                        v-model="form.contact_number"-->
                                <!--                                                        required-->
                                <!--                                                        id="input-default"-->
                                <!--                                                        v-mask="'+998(##)###-##-##'"-->
                                <!--                                                ></b-form-input>-->
                                <!--                                                <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                            </validation-provider>-->
                                <!--                                        </b-form-group>-->
                                <!--                                    </div>-->
                                <!--                                    <div class="w-100 mt-4">-->
                                <!--                                        <label>{{$t('message.Note')}}</label>-->
                                <!--                                        <validation-provider rules="required" v-slot="{errors}"-->
                                <!--                                                             :name="$t('message.Note')">-->
                                <!--                                            <b-form-textarea-->
                                <!--                                                    v-model="form.description"-->
                                <!--                                                    id="textarea-rows"-->
                                <!--                                                    rows="6"-->
                                <!--                                            ></b-form-textarea>-->
                                <!--                                            <span class="text-danger">{{errors[0]}}</span>-->
                                <!--                                        </validation-provider>-->
                                <!--                                    </div>-->
                                <!--                                </b-col>-->
                            </b-row>
                        </validation-observer>
                    </b-card>
                </div>
                <br>
                <div class="mt-4 d-flex justify-content-end mb-5 pe-5">
                    <b-button
                            class="btn"
                            variant="primary"
                            @click="cancelTo"
                    >{{$t('message.Cancel')}}
                    </b-button>
                    <b-button
                            variant="outline-primary"
                            @click="handleSubmit"
                    >{{$t('message.Add')}}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import Layout from "../../../../../../layouts/main";
    import SideBar from "../../../../../../components/side-bar";
    import router from "@/router";
    import {layoutComputed} from "@/state/helpers";
    import {
        addSchoolJobFVacancy, editSchoolJobFVacancy,
        showSchoolVacancy
    } from "../../../../../../api/school_job_vacancy";
    import {getSchoolJobVacancyCreds} from "../../../../../../api/school_job_vacancy_creds";
    import {getRayons} from "../../../../../../api/regions";
    import {getSchools} from "../../../../../../api/schools";
    import {getPositions} from "../../../../../../api/directories";
    // import {addAddJob, editAddJob} from "../../../../../../api/add_job";
    import {mask} from 'vue-the-mask';
    import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
    import * as rules from 'vee-validate/dist/rules';
    import {messages} from 'vee-validate/dist/locale/ru.json';
    import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {quillEditor} from 'vue-quill-editor';

    Object.keys(rules).forEach(rule => {
        extend(rule, {
            ...rules[rule],
            message: messages[rule]
        });
    });


    export default {
        name: "AddJob",
        components: {
            HorizontalTopbarInside, SideBar,
            ValidationObserver,
            ValidationProvider,
            quillEditor
        },
        directives: {mask},
        data() {
            return {
                id: {
                    default: null,
                },
                isMenuCondensed: false,
                value: 3,
                selected: null,
                regions: [],
                rayons: [],
                schools: [],
                position_level: [],
                positions: [],
                lesson_language: [],
                second_lang: [],
                work_experience: [],
                education: [],
                job_type: [],
                payment_type: [],
                work_place: [],
                form: {
                    region_id: null,
                    rayon_id: null,
                    school_id: null,
                    position_level_id: null,
                    position_id: null,
                    lesson_language_id: null,
                    lesson_language_id2: null,
                    work_experience_id: null,
                    education_id: null,
                    job_type_id: null,
                    payment_type_id: null,
                    workplace_employment_id: null,
                    vacancy_count: '',
                    deadline: '',
                    contact_number: '',
                    privileges: '',
                    description: '<p><br></p><p><strong>School:</strong> SOBE&nbsp;</p><p><br></p><p><strong>Department: </strong>Finance</p><p><br></p><p><strong>Reports to:</strong> Head of the department</p><p><br></p><p><strong>Duty station: </strong>Tashkent, Uzbekistan</p><p><br></p><p><strong>Opening date:</strong> 27.06.2022</p><p><br></p><p><strong>Deadline: </strong>31.07.2022</p><p><br></p><p><strong>Background</strong></p><p><em>example</em></p><p><br></p><p><strong>Summary of Position and Key Responsibilities</strong></p><p><em>example</em></p><p><br></p><p><strong>PRINCIPAL ACCOUNTABILITIES:&nbsp;</strong></p><p><br></p><p><strong>Leadership</strong></p><ul><li>example</li><li>example</li></ul><p><br></p><p><strong>PERSON SPECIFICATION</strong></p><ul><li>example</li><li>example</li></ul><p><br></p><p><strong>QUALIFICATIONS</strong></p><p>example</p><p><br></p><p><strong>EXPERIENCE</strong></p><p>example</p><p><br></p><p><strong>How to Apply</strong></p><p><em>To apply please complete the application form online and upload:</em></p><ol><li><em>Cover letter</em></li><li><em>CV</em></li><li><em>Copies of diplomas and transcripts (Bachelors, Masters and PhD if applicable)</em></li><li><em>Contact information for three professional references</em></li><li><em>Scanned copy of your previous performance evaluation report</em></li><li><em>Statement of your vision for the position</em></li></ol><p><br></p><p>Note: Other attachments can be skipped.</p>',
                    salary: '',
                },
                editorOption: {
                    debug: 'info',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            // ['blockquote', 'code-block'],

                            [{'header': 1}, {'header': 2}],               // custom button values
                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                            [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                            // [{'direction': 'rtl'}],                         // text direction

                            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                            // [{'header': [1, 2, 3, 4, 5, 6, false]}],

                            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                            // [{'font': []}],
                            [{'align': []}],

                            ['clean']                                         // remove formatting button
                        ]
                    },
                    placeholder: 'Compose an epic...',
                    // readOnly: true,
                    theme: 'snow'
                }
            };
        },
        computed: {
            ...layoutComputed,
        },
        created() {
            if (this.$route.params.id) {
                showSchoolVacancy(this.$route.params.id).then(response => {
                    this.form = response.data.data
                })
            }
            document.body.removeAttribute("data-layout", "horizontal");
            document.body.removeAttribute("data-topbar", "dark");
            document.body.removeAttribute("data-layout-size", "boxed");
            document.body.classList.remove("auth-body-bg");
            this.fetchCreds()
        },
        methods: {
            fetchCreds() {
                getSchoolJobVacancyCreds().then(response => {
                    this.regions = response.data.regions.original.data;
                    this.position_level = response.data.position_levels.original.data;
                    this.lesson_language = response.data.lesson_languages.original.data;
                    this.second_lang = response.data.lesson_languages.original.data;
                    this.work_experience = response.data.work_experiences.original.data;
                    this.education = response.data.educations.original.data;
                    this.job_type = response.data.job_types.original.data;
                    this.payment_type = response.data.payments.original.data;
                    this.work_place = response.data.work_places.original.data;
                })
            },
            async handleSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    if (this.$route.params.id) {
                        editSchoolJobFVacancy(this.form).then(() => {
                            this.$router.push({name: 'fjobs'})
                        })
                    } else {
                        addSchoolJobFVacancy(this.form).then(() => {
                            this.$router.push({name: 'fjobs'})
                        })
                    }
                }
            },
            fetchRayons() {
                getRayons(this.form.region_id).then(response => {
                    this.rayons = response.data.data
                })
            },
            fetchSchools() {
                getSchools({oblastid: this.form.region_id, regionid: this.form.rayon_id}).then(response => {
                    this.schools = response.data.data
                })
            },
            fetchPosition() {
                getPositions({position_level_id: this.form.position_level_id}).then(response => {
                    this.positions = response.data.data
                })
            },
            cancelTo() {
                this.$router.push({name: 'jobs'})
            },
            toggleMenu() {
                document.body.classList.toggle("sidebar-enable");

                if (window.screen.width >= 992) {
                    // eslint-disable-next-line no-unused-vars
                    router.afterEach((routeTo, routeFrom) => {
                        document.body.classList.remove("sidebar-enable");
                        document.body.classList.remove("vertical-collpsed");
                    });
                    document.body.classList.toggle("vertical-collpsed");
                } else {
                    // eslint-disable-next-line no-unused-vars
                    router.afterEach((routeTo, routeFrom) => {
                        document.body.classList.remove("sidebar-enable");
                    });
                    document.body.classList.remove("vertical-collpsed");
                }
                this.isMenuCondensed = !this.isMenuCondensed;
            },
            toggleRightSidebar() {
                document.body.classList.toggle("right-bar-enabled");
            },
            hideRightSidebar() {
                document.body.classList.remove("right-bar-enabled");
            },
        },
        mounted() {
            if (this.loader === true) {
                document.getElementById("preloader").style.display = "block";
                document.getElementById("status").style.display = "block";

                setTimeout(function () {
                    document.getElementById("preloader").style.display = "none";
                    document.getElementById("status").style.display = "none";
                }, 2500);
            } else {
                document.getElementById("preloader").style.display = "none";
                document.getElementById("status").style.display = "none";
            }
        },
    }
</script>

<style scoped>
    h2 {
        margin-left: 70px;
        margin-bottom: 50px;
        color: #4d63cf;
    }

    .btn {
        border-radius: 10px;
        margin-left: 15px;
        width: 130px;
    }

</style>



